import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sanitizeHtml'
})
export class SanitizeHtmlPipe implements PipeTransform {
  transform(html: string): string {

    if (!html) return '';

    // Geçici bir div elemanı oluşturarak HTML'i içine yerleştiriyoruz
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    // İçerikteki img etiketlerini temizliyoruz
    const images = tempDiv.getElementsByTagName('img');
    while (images[0]) {
      images[0].parentNode?.removeChild(images[0]);
    }

    // <br> etiketlerini boşluk karakteriyle değiştiriyoruz
    tempDiv.innerHTML = tempDiv.innerHTML.replace(/<br\s*\/?>/gi, ' ');

    // Yalnızca düz metni döndürüyoruz
    return tempDiv.textContent || tempDiv.innerText || '';
  }
}
